(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/match-init-box/helpers/match-init-helper.js') >= 0) return;  svs.modules.push('/components/sport/match-init-box/helpers/match-init-helper.js'); 

'use strict';

(function() {
  var serverSide = typeof exports === 'object';
  if (!serverSide) {
    registerHelpers(Handlebars);
  }

  function registerHelpers(hbs) {
    hbs.registerHelper('initBox', function(data, isHorizontal) {
      if (!data) {
        return new hbs.SafeString(
          '<div class="align-center match-init "><i class="init-icon icon-default"></i></div>'
        );
      }

      var ret = '';

      if (data.error) {
        return new hbs.SafeString(
          '<div class="align-center match-init "><i class="init-icon icon-default icon-exclamation-sign brick"></i></div>'
        );
      }

      ret += getSpelStoppInfo(data, isHorizontal);

      if (!data.hideMatchInfo) {
        ret += getMatchInfo(data, isHorizontal);
      }

      return new hbs.SafeString(ret);
    });

    function getMatchInfo(data, isHorizontal) {
      var ret = '',
        live = '',
        isLive = getTemplateFunction('isLive', data.sport, data.status.id),
        isEnded = getTemplateFunction('isEnded', data.sport, data.status.id),
        matchStatus = _.isNumber(data.status.id) ? data.status.id : '',
        matchId = _.isNumber(data.matchId) ? data.matchId : '',
        matchInfo = '',
        stackClass = isHorizontal ? 'init-horizontal ' : 'align-center ';

      data.timeId = new Date().getTime();

      if (data.status.text) {
        matchInfo =
          '<div class="brick match-status brick-active f-condensed align-center">' +
          data.status.text +
          '</div>';
      } else {
        matchInfo = getTemplateFunction('initStatusStart', data.sport, data);
      }

      if (isLive) {
        live = 'match-live';
      } else if (Boolean(data.opt.startedLiveDraw) && !isEnded) {
        live = 'match-live live-draw';
      }

      ret +=
        '<div data-init-time-status="' +
        data.timeId +
        '" data-init-id="' +
        matchId +
        '" data-match-status="' +
        matchStatus +
        '" class="match-init ' +
        stackClass +
        live +
        '">';

      if (
        data.opt.tv && !isEnded ||
        data.opt.live && !isEnded ||
        data.opt.date
      ) {
        ret += '<div class="top-init">';
        ret +=
          data.opt.tv && !isEnded
            ? '<i class="icon-default icon-tv"title ="' +
              getTvChannels(data.opt.tv) +
              '"></i>'
            : '';
        ret +=
          data.opt.live && !isEnded
            ? '<span class="init-live-bet f-condensed">LIVESPEL</span>'
            : '';
        ret += getStartText(data);
        ret += data.opt.date && !isLive ? getDate(data.startTime, true) : '';
        ret += '</div>';
      }

      ret += matchInfo;
      ret += '</div>';

      return ret;
    }

    function getSpelStoppInfo(data, isHorizontal) {
      var ret = '',
        isLive = getTemplateFunction('isLive', data.sport, data.status.id),
        isEnded = getTemplateFunction('isEnded', data.sport, data.status.id),
        stackClass = isHorizontal ? 'init-horizontal ' : 'align-center ',
        cssClasses = '';

      if (Boolean(data.opt.spelstopp) && (!isLive && !isEnded)) {
        cssClasses += data.opt.tv ? ' has-tv' : '';
        cssClasses += data.opt.live ? ' has-live-bet' : '';

        ret += '<div class="spelstopp-init ' + stackClass + cssClasses + '">';
        ret +=
          data.opt.tv && data.hideMatchInfo
            ? '<i class="icon-default icon-tv" title ="' +
              getTvChannels(data.opt.tv) +
              '"></i>'
            : '';
        ret +=
          data.opt.live && data.hideMatchInfo
            ? '<span class="init-live-bet f-condensed">LIVESPEL</span>'
            : '';
        ret += getSpelstoppTime(data.opt.spelstopp);
        ret +=
          '<span class="brick brick-inactive brick-border f-condensed align-center">';
        ret += moment(data.opt.spelstopp).format('HH:mm');
        ret += '</span>';
        ret += '</div>';
      }

      return ret;
    }

    function getSpelstoppTime(time) {
      var ret = '',
        dateText = getDate(time, true, false);

      if (dateText) {
        ret += '<span class="init-date init-date-outer">';
        ret += dateText;
        ret += '</span>';
      }

      return ret;
    }

    function getStartText(data) {
      var hasStarted = getTemplateFunction(
        'hasStarted',
        data.sport,
        data.status.id
      );

      if (data.showStartText && !hasStarted) {
        return '<span class="init-date f-condensed align-center text-date">Startar</span>';
      }
      return '';
    }

    function getDate(time, text, toDayText) {
      var diff;
      if (window.moment && Boolean(time)) {
        if (text) {
          diff = Math.floor(
            moment(time).diff(moment().startOf('day'), 'days', true)
          );
          if (diff === 1) {
            return '<span class="init-date f-condensed align-center"><span class="text-date">Imorgon</span></span>';
          } else if (diff === 0) {
            if (toDayText) {
              return '<span class="init-date f-condensed align-center"><span class="text-date">Idag</span></span>';
            }
            return '';
          } else if (diff < 0) {
            return ''; 
          }
        }
        return (
          '<span class="init-date f-condensed align-center">' +
          moment(time).format('D/M') +
          '</span>'
        );
      }
    }

    function getTemplateFunction(func, sportId, args) {
      var returner = false,
        theme = new svs.sport.themeLoader({ sport: sportId });

      theme.load(function(template, init) {
        if (init) {
          returner = init(func, args);
        }
      }, 'init');

      return returner;
    }

    function getTvChannels(tvData) {
      var tvChannels = '',
        tvChannelsArr = [];

      _.each(tvData, function(obj) {
        tvChannelsArr.push(obj.channelName);
      });

      tvChannels = tvChannelsArr.join(', ');

      return tvChannels;
    }
  }
})();

 })(window);